import { useState, useEffect } from "react";
import { X } from "lucide-react";
import Logo from "/Logo.png";
import "./MenuOverlay.css";

interface MenuProps {
  open: boolean;
  onClose: () => void;
}

export default function MenuOverlay({ open, onClose }: MenuProps) {
  const [isAnimating, setIsAnimating] = useState(false);
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    if (open) {
      setIsVisible(true);
      requestAnimationFrame(() => setIsAnimating(true));
    } else if (isVisible) {
      setIsAnimating(false);
      const timer = setTimeout(() => setIsVisible(false), 1100);
      return () => clearTimeout(timer);
    }
  }, [open]);

  if (!isVisible) return null;

  const links = [
    { label: "Home", href: "/" },
    { label: "About", href: "/about" },
    { label: "Agents", href: "/agents" },
    { label: "Hotel Agent", href: "/hotel" },
    { label: "Restaurent Agent", href: "/4estaurent" },
    { label: "Contact", href: "/contact" },
  ];

  return (
    <div className={`menu-overlay ${isAnimating ? "open" : "closing"}`}>
      <div className="menu-left">
        {links.map((link) => (
          <a
            key={link.label}
            href={link.href}
            className="menu-link"
            onClick={onClose}
          >
            {link.label}
          </a>
        ))}
      </div>

      <div className="menu-right">
        <button className="close-btn" onClick={onClose}>
          <X size={34} strokeWidth={1.5} />
        </button>

        <img src={Logo} alt="AI Squared Logo" className="menu-logo" />

        <div className="menu-buttons">
          <button className="menu-btn" onClick={() => (window.location.href = "/agents")}>
            Explore Agents
          </button>

          <button className="menu-btn" onClick={() => (window.location.href = "/demo")}>
            Book a Demo
          </button>
        </div>
      </div>
    </div>
  );
}
